import {Directive, ElementRef, HostListener, Input, OnDestroy} from '@angular/core';

type TooltipPosition = 'left' | 'right';
const DEFAULT_TOOLTIP_INDENT_Y = 4;
const DEFAULT_TOOLTIP_INDENT_X = 5;
const DEFAULT_TOOLTIP_WIDTH_PX = 438;
@Directive({
  selector: '[tooltip]',
})
export class TooltipDirective implements OnDestroy {
  @Input() tooltip: string = '';
  @Input() tooltipPosition: TooltipPosition = 'right';
  @Input() centerTooltipInParent: boolean;
  @Input() tooltipId: string;
  @Input() shouldShowTooltip: boolean = true;
  private popup: HTMLElement;
  constructor(private el: ElementRef) {}

  @HostListener('mouseenter', ['$event'])
  @HostListener('focus', ['$event'])
  onMouseEnter(event: MouseEvent): void {
    this.removeTooltipPopup();
    const parentElement = this.el.nativeElement;
    const targetCoordinates = parentElement.getBoundingClientRect();
    let x = (event.clientX || targetCoordinates.x) + DEFAULT_TOOLTIP_INDENT_X;
    if (this.centerTooltipInParent) {
      x = targetCoordinates.left + targetCoordinates.width / 2;
    }
    const yBottom = targetCoordinates.bottom + DEFAULT_TOOLTIP_INDENT_Y;
    const yTop = targetCoordinates.top - DEFAULT_TOOLTIP_INDENT_Y; // For inverted tooltip
    this.createTooltipPopup(x, yBottom, yTop);
  }

  @HostListener('blur', ['$event'])
  @HostListener('mouseleave')
  onMouseLeaveOrBlur(): void {
    this.removeTooltipPopup();
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey() {
    this.removeTooltipPopup();
    this.el.nativeElement.blur();
  }

  ngOnDestroy(): void {
    this.removeTooltipPopup();
  }

  private createTooltipPopup(x: number, yBottom: number, yTop: number): void {
    if (!this.shouldShowTooltip) return;

    const popup = document.createElement('div');
    popup.textContent = this.tooltip;
    popup.classList.add('mc-tooltip');
    popup.id = this.tooltipId;

    popup.setAttribute('role', 'tooltip');

    popup.style.top = yBottom.toString() + 'px';
    popup.style.left = x.toString() + 'px';

    document.body.appendChild(popup);

    const tooltipRect = popup.getBoundingClientRect();
    if (this.tooltipPosition === 'left' || tooltipRect.right >= window.innerWidth) {
      popup.classList.add('left');
      popup.style.left = (x - DEFAULT_TOOLTIP_WIDTH_PX).toString() + 'px';
    }
    if (tooltipRect.bottom >= window.innerHeight) {
      popup.classList.add('inverted');
      popup.style.top = (yTop - popup.offsetHeight).toString() + 'px';
    }
    this.popup = popup;
  }
  private removeTooltipPopup(): void {
    const popup = document.querySelector('.mc-tooltip');
    if (popup) {
      popup.remove();
    }
  }
}
